import React, { useContext, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Loading } from "../../components/Loading";
import DayInput from "react-day-picker/DayPickerInput";

import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";

const CreateUpdateModal = ({ open, handleUpdates }) => {
	const { handleOpenModal } = useContext(ModalContext);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedDay, setSelectedDay] = useState(new Date());

	const title = useRef(null);
	const version = useRef(null);

	const handleDayChange = (day) => {
		setSelectedDay(day);
	};

	const handleUpdateCreate = async () => {
		if (!title.current) {
			return;
		}
		try {
			setIsLoading(true);
			const data = {
				title: title.current.value,
				updateDate: selectedDay,
				version: version.current.value,
			};
			await authApi.post("/updates", data);
			setIsLoading(false);
			handleUpdates();
			handleOpenModal();
		} catch (error) {
			handleOpenModal();
			setIsLoading(false);
		}
	};

	return (
		<Modal
			show={open}
			onHide={handleOpenModal}
			size="lg"
			backdrop="static"
			animation={false}
		>
			{isLoading && <Loading />}
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Cadastrar nova atualização</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<label>Título da atualização</label>
					<MyModalInput
						ref={title}
						type="text"
						placeholder="ex: Sem mais problemas para gerar relatórios"
					/>
					<label>Versão da extensão</label>
					<MyModalInput ref={version} type="text" placeholder="ex: 1.0.0" />
					<label>Data da atualização</label>
					<DayInput
						placeholder="Ex: 27/07/2021"
						onDayChange={handleDayChange}
						value={selectedDay}
					/>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleUpdateCreate}>Cadastrar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
};

export { CreateUpdateModal };
